import React from 'react';
import css from './styles.module.scss';
import { Button, Typography } from '@material-ui/core';

interface NameWrapperProps {
    name?: string;
    onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
    style?: any;
    action?: {
        label: string;
        handler(): void;
    }
}

export const NamedForm: React.FC<NameWrapperProps> = ({ name, children, onSubmit, style, action }) => {
    return (
        <div className={css.module} style={style}>
            <form className={css.form} onSubmit={onSubmit}>
                {name && (
                    <div className={css.nameWrapper}>
                        <Typography className={css.name} variant={'h5'}>
                            {name}
                        </Typography>
                        {action && <Button variant="text" onClick={action.handler} className={css.action}>{action.label}</Button>}
                    </div>
                )}
                <div className={css.contentWrapper}>{children}</div>
            </form>
        </div>
    );
};
